import React from 'react';
import { Toolbar, IconButton } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { backendUrl } from '../App';
import * as orderActions from '../actions/orderActions';
import { printTicket } from '../helpers/utils';
import Order from './Order';
import Print from './Print';

import printer_logo from '../assets/img/printer.png';
import trash_logo from '../assets/img/garbage.png';

const Bill = ({order, ...props}) => {
    const [printOrder, setPrintOrder] = React.useState({...order});

    const clearOrder = () =>{
        props.actions.clearOrder();
    };

    const createOrder = () => {
        if(order.lines && order.lines.length > 0){
            const token = sessionStorage.getItem('rtvcrespoToken');
            return fetch(`${backendUrl}/orders/create`,{
                method: 'POST',
                headers: new Headers({
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(order)
            }).then(response => {
                return response;
            });
        }
    };

    const createAndPrinTicket = async () => {
        if(order.lines && order.lines.length > 0){
            const response = await createOrder();
            const createdOrder = await response.json();
            const newPrintOrder = {...order};
            newPrintOrder.ticketId = createdOrder.id;
            setPrintOrder(newPrintOrder);
            setTimeout(() => {
                printTicket(clearOrder);
            }, 100);
        }
    }

    return(
        <div className="full-height border-bill">
            <Toolbar className="toolbar-bill">
                <div style={{margin: '0 auto'}}>
                    <h5 className="toolbar-bill-title">FACTURA</h5>
                </div>

                <IconButton className="clear-btn" onClick={clearOrder}>
                    <img src={trash_logo} alt="trash_logo" />
                </IconButton>

                <IconButton className="printer-btn" onClick={createAndPrinTicket}>
                    <img src={printer_logo} alt="printer_logo" />
                </IconButton>
            </Toolbar>
            <Order/>
            <div className="bottombar-bill">
                <div className="bottombar-total-container">
                    <div className="bottombar-total-text">
                        <h5>TOTAL</h5>
                    </div>
                    <div className="bottombar-total-amount">
                        <span>{order.total} €</span>
                    </div>
                </div>
            </div>
            <Print order={printOrder}/>
        </div>
    )
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(orderActions, dispatch)
    };
}

const mapStateToProps = (state) => ({
    main: state.main,
    order: state.order
});

export default connect(mapStateToProps,mapDispatchToProps)(Bill);


// WEBPACK FOOTER //
// ./src/components/Bill.js